export enum EnumCountryCode {
  BR = 'BRA',
  AR = 'ARG',
  PE = 'PE',
  CL = 'CHL',
  NOT_DEFINED = 'NOT DEFINED',
}
